export default __webpack_public_path__ + "016cb596072f13de3d7a36f30a1964df.otf";